import { Component, h, Prop, Watch, Element } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';
import { DEFAULT_TRACKING_DELAY, delayPageChange } from '../../../global/utility/tracking-helpers';

export interface UiCmsContactChannelsFooterEmailBody {
  emailAddress: string;
}
@Component({
  tag: 'ui-cms-contact-channels-footer-email',
  styleUrl: 'ui-cms-contact-channels-footer-email.scss',
})
export class UiCmsContactChannelsFooterEmail {
  @Element() el: HTMLUiCmsContactChannelsFooterEmailElement;

  @Prop({ mutable: true }) body: UiCmsContactChannelsFooterEmailBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop({ mutable: true }) i18n: { [key: string]: string } = { content: 'Per <strong>E-Mail</strong> unter' };

  @Prop({ attribute: 'i18n' }) utilityI18n: string;

  @Prop() inverted: boolean;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  @Watch('utilityI18n')
  i18nChangeHandler(newValue: string) {
    if (newValue) this.i18n = { ...this.i18n, ...JSON.parse(newValue) };
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
    this.i18nChangeHandler(this.utilityI18n);
  }

  onLinkClick(event: Event, link: HTMLAnchorElement) {
    delayPageChange(DEFAULT_TRACKING_DELAY, event, link);
    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Contact Email',
        eventType: 'Action',
        eventCaller: this.el,
      },
      attributes: {
        elementType: 'Link',
        elementLabel: this.body.emailAddress,
        externalTarget: this.body.emailAddress,
      },
      category: {
        area: 'Footer',
      },
    };

    if (trackingEvent) {
      window.ui?.services?.tracking?.track(trackingEvent);
    }
  }

  render() {
    const mail = `mailto:${this.body.emailAddress}`;
    return (
      <div class="contactbox__item">
        <sd-icon
          class="contactbox__icon"
          library={window.ui.cmsState.iconLibrary}
          name="union-investment/content/letter"
          color={this.inverted ? 'white' : 'primary'}
        ></sd-icon>
        <p class={{ copy: true, 'sd-paragraph': true, 'sd-paragraph--inverted': this.inverted }}>
          <span innerHTML={this.i18n.content || 'Per <strong>E-Mail</strong> unter'}></span>{' '}
          <sd-link
            inverted={this.inverted}
            itemProp="email"
            size="inherit"
            href={mail}
            target="_blank"
            onClick={(event: Event) => this.onLinkClick(event, event.currentTarget as HTMLAnchorElement)}
          >
            <span innerHTML={this.body.emailAddress}></span>
          </sd-link>
        </p>
      </div>
    );
  }
}
